<template>
  <div>
    <v-card-title @click="handleExpand">
      <v-list v-if="orderDetails" class="pa-0 w-100" two-line>
        <v-layout row wrap class="order-history">
          <v-flex xs12>
            <v-list-tile-content>
              <v-list-tile-title class="extend-height">
                {{ order.storeName || getStore.name }}
                <order-progress-chip v-if="$vuetify.breakpoint.name != 'xs'"
                  :status="!!order.refundDate ? 'REFUNDED' : order.orderProgressStatus"
                />
              </v-list-tile-title>
              
              <order-progress-chip v-if="$vuetify.breakpoint.name == 'xs'"
                :status="!!order.refundDate ? 'REFUNDED' : order.orderProgressStatus"
              />

              <v-list-tile-sub-title>
                {{ $vuetify.t('$vuetify.account.orderId') }}: {{ displayId }}
              </v-list-tile-sub-title>

              <v-list-tile-sub-title>
                {{ $vuetify.t('$vuetify.order.orderPlaced') }}: {{ formatDate(order.orderDateStr || order.createTime) }}
              </v-list-tile-sub-title>

              <v-list-tile-sub-title v-if="!!scheduledTime">
                {{ $vuetify.t('$vuetify.order.orderScheduled') }}: {{ formatDate(scheduledTime) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-flex>

          <v-flex xs12>
            <hr/>
            <v-list-tile-action :class="{'reAlignTotal': $vuetify.breakpoint.name == 'xs'}">
              <span class="subheading">
                {{ $vuetify.t('$vuetify.cart.total') }}:
                <span :class="{'subheading black--text': $vuetify.breakpoint.name !== 'xs'}">
                  {{ order.orderTotal || orderDetails.totalAmount | currency }}
                </span>
              </span>
            </v-list-tile-action>
          </v-flex>
        </v-layout>
      </v-list>
      <v-icon class="ml-auto">{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-card-title>

    <v-expand-transition>
      <div v-show="expanded">
        <v-divider></v-divider>
          <order-history-detail :order-id="order.orderId" />
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import OrderHistoryDetail from '@/components/Account/OrderHistoryDetail.vue'
  import OrderProgressChip from '@/components/OrderProgressChip.vue'

  import moment from 'moment-timezone'
  import get from 'lodash/get';


  export default {
    props: {
      order: {
        type: Object,
        default: () => {}
      },
      expanded: {
        type: Boolean,
        default: false
      }
    },

    components: {
      OrderHistoryDetail,
      OrderProgressChip
    },

    data: () => ({
      prettyType: {
        'DELIVERY': 'Delivery',
        'PICKUP': 'Pick Up',
        'DINE_IN': 'Dine In'
      }
    }),
    watch: {
      expanded(val) {
        if (val) {
          this.onOrderHistoryClick();
        }
      }
    },
    computed: {
      orderDetails() {
        if (this.order && !!this.order.orderId)
          return this.getOrder(this.order.orderId)
      },
      scheduledTime() {
        // Using a dedicated computed property for this seems to help the reactiveness
        if (this.orderDetails && !!this.orderDetails.scheduledTime) { 
          const storeTimezone = this.getStore.timeZone
          if (storeTimezone) {
            const momentDate = moment(this.orderDetails.scheduledTime)
            const convertedDate =  moment.tz(momentDate, moment.tz.guess()) 
            return convertedDate.tz(storeTimezone).tz(moment.tz.guess(), true).toISOString()
          }
          // return this.orderDetails.scheduledTime
        }
      },

      displayId() {
        // displayId is new so only enable if the merchant has specificed to avoid confusion
        const _useDisplayId = get(this.getStore, 'settings.orderSettings.useDisplayId', false)
        const _displayId = get(this.order, 'displayId')
        const _orderId = get(this.order, 'orderId')

        return _useDisplayId ? (_displayId || _orderId) : _orderId
      },

      ...mapGetters([ 'getOrder', 'getStore' ])
    },

    methods: {
      handleExpand() {
        this.$emit('expand');
      },
      formatDate(dateStr) {
        return moment(dateStr).format('MMM Do, YYYY @ hh:mm a')
      },

      onOrderHistoryClick() {
        const { orderId, storeId } = this.order
        const payload = { orderId, storeId }

        this.$store.dispatch('ensureOrder', payload)
      }
    }
  }
</script>
<!-- 
<style>
  .order-history .v-list__tile__title {
    font-size: var(--text-size-2);
  }
  .order-history .v-list__tile__sub-title,
  .order-history .v-list__tile__action {
    font-size: var(--text-size-1);
  }

  .order-history .v-list__tile {
    padding: 0;
  }
  .order-history .extend-height {
    min-height: 34px !important;
  }
</style>
<style scoped>
.order-history {
  cursor: pointer;
}

.order-history .v-list__tile__title {
  font-size: var(--text-size-2);
}

.order-history .v-list__tile__sub-title,
.order-history .v-list__tile__action {
  font-size: var(--text-size-1);
}

.order-history .v-list__tile {
  padding: 0;
}

.order-history .extend-height {
  min-height: 34px !important;
}

.reAlignTotal {
  align-items: flex-start !important;
  justify-content: flex-start !important;
}

.reAlignTotal span {
  margin-top: 10px;
}

.subheading {
  display: block;
}

.v-list__tile__action {
  justify-content: flex-start;
}

.v-icon {
  transition: transform 0.3s ease;
}

.v-card-title {
  display: flex !important;
  width: 100% !important;
  align-items: flex-start;
  padding: 0 !important; 
}

.v-card-text {
  padding: 0 !important;
} 

.v-list {
  width: 100% !important;
  flex: 1;
}

.order-history {
  width: 100% !important;
  flex: 1;
}

</style> -->
<style scoped>
.v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px !important;
}

.order-history {
  width: 100%;
}

.order-history .v-list__tile__title {
  font-size: 16px !important;
  font-weight: 900 !important;
  line-height: 1.4 !important;
}

.order-history .v-list__tile__sub-title {
  font-size: 12px !important;
  margin-top: 4px !important;
}

.order-history .v-list__tile__content {
  padding-bottom: 5px !important;
}

.extend-height {
  min-height: 34px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-card-text {
  padding: 16px !important;
  background-color: #fff;
}

.order-details {
  padding: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #fcfcfc;
}

.v-icon {
  transition: transform 0.3s ease;
  color: #606f7b;
}

.expanded .v-icon {
  transform: rotate(180deg);
}

.order-progress-chip {
  margin-left: auto;
  font-size: 12px !important;
  font-weight: 500 !important;
}
.order-history .v-list__tile__sub-title {
  font-size: 12px !important;
  margin-top: 4px !important;
  color: rgba(0, 0, 0, 0.87) !important; 
}
.subheading {
  font-size: 12px !important;
  margin-top: 4px !important;
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.87) !important; 
}
hr {
  border: none;
  height: 1px;
  background-color: #D9D9D9; 
  margin: 0;
}
@media (max-width: 599px) {
    .v-card-title {
        padding: 12px !important;
    }

    .order-history .v-list__tile__title {
        font-size: 14px !important;
    }

    .order-history .v-list__tile__sub-title {
        font-size: 12px !important;
    }
}
</style>